import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const HomeEnPage = lazy(() => import('../pages/home-en/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const SolutionsPage = lazy(() => import('../pages/solutions/page'));
const IndustriesPage = lazy(() => import('../pages/industries/page'));
const InsightsPage = lazy(() => import('../pages/insights/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/en',
    element: <HomeEnPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/solutions',
    element: <SolutionsPage />
  },
  {
    path: '/industries',
    element: <IndustriesPage />
  },
  {
    path: '/insights',
    element: <InsightsPage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/careers',
    element: <CareersPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
